import React from 'react';
import block from 'bem-cn-lite';

import './CloudTag.scss';

const b = block('CloudTag');

export type CloudTagSize = 's' | 'n';

export enum CloudTagTheme {
    Light = 'light',
    Dark = 'dark',
    Special = 'special',
    Transparent = 'transparent',
    Calculator = 'calculator',
}

export interface CloudTagProps {
    size?: CloudTagSize;
    theme?: CloudTagTheme;
    active?: boolean;
    className?: string;
    cropText?: boolean;
    dataQa?: string;
    onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

const CloudTag: React.FC<CloudTagProps> = (props) => {
    const {
        size = 's',
        theme = 'light',
        active = false,
        onClick,
        className,
        children,
        cropText,
        dataQa,
    } = props;

    return (
        <span
            className={b({size, theme, active, cropText}, className)}
            onClick={onClick}
            data-qa={dataQa}
        >
            {children}
        </span>
    );
};

export default CloudTag;
